import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';
import { siteDisclaimers } from '../content/disclaimers';

const SiteDisclaimers: React.FC = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section id="disclaimers" className="py-24 bg-white" aria-labelledby="disclaimers-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2
            id="disclaimers-heading"
            className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-center text-text-dark mb-6"
          >
            Important{' '}
            <span className="bg-gradient-to-r from-primary to-primary-light bg-clip-text text-transparent">
              information
            </span>
          </h2>
          <p className="text-base md:text-lg text-text-light text-center mb-16 max-w-3xl mx-auto font-light">
            Comfort is for personal use only. Please read these notes before using the app.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {siteDisclaimers.map((item, index) => (
              <motion.article
                key={item.id}
                initial={{ opacity: 0, y: 30 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-gradient-to-br from-white to-background-light p-8 rounded-3xl shadow-xl border border-gray-100 h-full"
              >
                <h3 className="text-lg md:text-xl font-bold text-text-dark mb-4">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base text-text-light leading-relaxed font-light mb-4">
                  {item.body}
                </p>
                <p className="text-sm md:text-base font-semibold text-text-dark leading-relaxed">
                  {item.emphasisTitle ? (
                    <>
                      {item.emphasisTitle} {item.emphasis}
                    </>
                  ) : (
                    item.emphasis
                  )}
                </p>
              </motion.article>
            ))}
          </div>

          <p className="text-center mt-10">
            <Link
              to="/disclaimers"
              className="text-primary hover:text-primary-dark font-medium"
            >
              Read the full disclaimers
            </Link>
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default SiteDisclaimers;
